import React, { useState, useEffect, useRef } from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import "./nav.css";
import { trackNavigation } from "../../utils/analytics";

// Must match --nav-height in nav.css
export const NAV_HEIGHT = 120;

function Nav() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("lusaduma-mata");
  const navRef = useRef(null);

  useEffect(() => {
    const sections = [
      { id: "lusaduma-mata", element: null },
      { id: "about", element: null },
      { id: "techstack", element: null },
      { id: "certificates", element: null },
      { id: "work", element: null },
      { id: "projects", element: null },
      { id: "contact", element: null }
    ];

    // Get all section elements
    sections.forEach(section => {
      section.element = document.getElementById(section.id);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.id;
            setActiveSection(sectionId);
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the section is visible
        rootMargin: "-110px 0px -50% 0px" // Account for navbar height, less restrictive bottom margin
      }
    );

    // Observe all sections
    sections.forEach(section => {
      if (section.element) {
        observer.observe(section.element);
      }
    });

    return () => {
      sections.forEach(section => {
        if (section.element) {
          observer.unobserve(section.element);
        }
      });
    };
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target) && isMenuOpen) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const scrollToTop = () => {
    scroll.scrollToTop({ duration: 500 });
  };

  return (
    <div>
      <nav className="navbar" ref={navRef}>
        <img
          src="/images/Me-removebg-preview.png"
          height={100}
          alt="Your Alt Text Here"
          onClick={scrollToTop}
          style={{ cursor: "pointer" }}
        />

        {/* Responsive menu */}
        <div
          className={`menu-icon ${isMenuOpen ? "hidden" : ""}`}
          id="menu-icon"
          onClick={handleMenuToggle}
          aria-expanded={isMenuOpen}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* Desktop view */}
        <ul className="menu" id="menu">
          <li>
            <Link
              to="lusaduma-mata"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={() => {
                closeMenu();
                trackNavigation('home');
              }}
              className={activeSection === "lusaduma-mata" ? "active" : ""}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="about"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "about" ? "active" : ""}
            >
              About Me
            </Link>
          </li>
          <li>
            <Link
              to="techstack"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "techstack" ? "active" : ""}
            >
              Tech Stack
            </Link>
          </li>
          <li>
            <Link
              to="certificates"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "certificates" ? "active" : ""}
            >
              Certifications
            </Link>
          </li>
          <li>
            <Link
              to="work"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "work" ? "active" : ""}
            >
              Work Experience
            </Link>
          </li>
          <li>
            <Link
              to="projects"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "projects" ? "active" : ""}
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="contact"
              smooth
              offset={-NAV_HEIGHT}
              duration={500}
              onClick={closeMenu}
              className={activeSection === "contact" ? "active" : ""}
            >
              Contact Me
            </Link>
          </li>
        </ul>

        {/* Mobile view */}
        {isMenuOpen && (
          <ul className={`menu-items ${isMenuOpen ? "open" : ""}`}>
            <li>
              <Link
                to="lusaduma-mata"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "lusaduma-mata" ? "active" : ""}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="about"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "about" ? "active" : ""}
              >
                About Me
              </Link>
            </li>
            <li>
              <Link
                to="techstack"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "techstack" ? "active" : ""}
              >
                Tech Stack
              </Link>
            </li>
            <li>
              <Link
                to="certificates"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "certificates" ? "active" : ""}
              >
                Certifications
              </Link>
            </li>
            <li>
              <Link
                to="work"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "work" ? "active" : ""}
              >
                Work Experience
              </Link>
            </li>
            <li>
              <Link
                to="projects"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "projects" ? "active" : ""}
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                onClick={closeMenu}
                className={activeSection === "contact" ? "active" : ""}
              >
                Contact Me
              </Link>
            </li>
          </ul>
        )}
      </nav>
      <div className="navbar-spacer" />
    </div>
  );
}

export default Nav;
